import React, { useState, useEffect } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { connect } from "react-redux";

function Dictaphone(props) {
  useEffect(
    () => {
      props.micOn && browserSupportsContinuousListening
        ? SpeechRecognition.startListening({ continuous: true })
        : SpeechRecognition.stopListening();
    },
    [props.micOn]
  );

  const commands = [
    {
      command: "knowledge search *",
      callback: (condition, second, third) => onSearch(condition),
    },
    {
      command: "clear",
      callback: ({ resetTranscript }) => resetTranscript(),
    },
  ];
  const onSearch = (searchString) => {
    console.log(searchString);
    props.handleSearch(searchString);
  };

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsContinuousListening,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition({ commands });

  if (!browserSupportsSpeechRecognition) {
    console.log("Browser does not support speech recognition.");
  }
  if (browserSupportsContinuousListening && props.micOn) {
    SpeechRecognition.startListening({ continuous: true });
  }
  return <></>;
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(Dictaphone);
